import { Card, CardContent, Container } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { Link } from 'react-router-dom'

function DataProtection() {
    return (
        <div className='app-bg' >
            <Container maxWidth='lg' sx={{ minHeight: '100vh', py: 10 }}>
                <Card>
                    <CardContent>
                        <h1>{t('dataProtection:link')}</h1>
                        <span dangerouslySetInnerHTML={{ __html: t('dataProtection:text') }}></span>
                        <br></br>
                        <Link style={{ paddingTop: 5 }} target='_blank' to={'https://equimetre-assets-next.s3.eu-west-3.amazonaws.com/build/legal/202106_Privacy_and_Data_Protection_Charter.pdf?38.1.0'}>{t('dataProtection:linkSeeMore')}</Link>
                    </CardContent>
                </Card>
            </Container>
        </div >
    )
}

export default DataProtection